/* eslint-disable */
import { fabric } from 'fabric';
import { cloneDeep } from 'lodash';
import {
  CIRCLE,
  generateId,
  getPathValue,
  MINIMUM_SIZE_SCALING,
  PATH,
  setPathDimensions,
  TEXTBOX,
  TEXT_COMPONENT,
  ungroup,
} from '../../utils';

export const EPS = 5;
export const CURLY_BRACE_NOTE_LEFT = 'Curly Brace Note Left';

fabric.TextComponent = fabric.util.createClass(fabric.Group, {
  initialize(objects, options) {
    this.callSuper('initialize', objects, options, true);
    this.on('scaling', this.onScaling);
  },
  onScaling: function () {
    const width = this.scaleX * this.width;
    const height = this.scaleY * this.height;
    this.set({
      width,
      height,
      scaleX: 1,
      scaleY: 1,
      flipX: false,
      flipY: false,
    });
  },
  getRectObj: function () {
    return this._objects.find((obj) => obj.type !== TEXTBOX);
  },
  getTextObj: function () {
    return this._objects.find((obj) => obj.type === TEXTBOX);
  },
  updateRectObj: function () {
    const rectObj = this.getRectObj();
    rectObj.set({
      width: this.width - rectObj.strokeWidth,
      height: this.height - rectObj.strokeWidth,
      left: -this.width / 2,
      top: -this.height / 2,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      id: rectObj.id || generateId(),
      shadow: {
        ...rectObj.shadow,
        affectStroke: rectObj.type === PATH,
      },
    });
    if (this.originalName === CURLY_BRACE_NOTE_LEFT) {
      rectObj.set({ left: this.width / 2 - rectObj.maxWidth });
    }
  },
  updateTextObj: function () {
    const rectObj = this.getRectObj();
    const textObj = this.getTextObj();
    textObj.set({
      width: this.width - rectObj.strokeWidth - EPS,
      scaleX: 1,
      scaleY: 1,
      parentId: rectObj.id,
      isTextComponent: true,
    });
    textObj.setCoords();
    textObj.set({
      left: -textObj.width / 2,
      visible: this.width > MINIMUM_SIZE_SCALING && this.height > MINIMUM_SIZE_SCALING,
    });
    switch (this.textAlignVertical) {
      case 'top':
        textObj.set({ top: -this.height / 2 + rectObj.strokeWidth, originY: 'top' });
        break;
      case 'middle':
        textObj.set({ top: 0, originY: 'center' });
        break;
      case 'bottom':
        textObj.set({ top: this.height / 2 - rectObj.strokeWidth, originY: 'bottom' });
        break;
    }
  },
  drawTextComponent: function (obj, stackOrder) {
    const textObj = obj.getTextObj();
    const rectObj = obj.getRectObj();
    window.canvas.remove(rectObj, textObj);
    textObj.set({ top: 0, left: 0, objectCaching: false, angle: 0, scaleX: 1, scaleY: 1 });
    rectObj.set({ top: -obj.height / 2, left: -obj.width / 2, objectCaching: false, angle: 0 });
    const newObj = new fabric.TextComponent([rectObj, textObj], obj);
    window.canvas.insertAt(newObj, stackOrder);
    window.canvas.setActiveObject(newObj);
    window.canvas.renderAll();
  },
  updateClipPath: function () {
    // const rectObj = this.getRectObj();
    // const clipPathObj = new fabric.Rect({
    //   width: this.width + rectObj.strokeWidth,
    //   height: this.height + rectObj.strokeWidth,
    //   left: -this.width / 2 - rectObj.strokeWidth / 2,
    //   top: -this.height / 2 - rectObj.strokeWidth / 2,
    //   strokeWidth: 0,
    // });
    this.noScaleCache = false;
    this.clipPath = null;
  },
  toObject(propertiesToInclude) {
    this.updateClipPath();
    const obj = this.callSuper(
      'toObject',
      ['objectCaching', 'id', 'name', 'textAlignVertical'].concat(propertiesToInclude),
    );
    return obj;
  },
  toSVG() {
    this.updateClipPath();
    return this.callSuper('toSVG');
  },
  render(ctx) {
    this.updateClipPath();
    this.updateRectObj();
    const rectObj = this.getRectObj();
    if (rectObj.type === PATH) {
      const pathValue = getPathValue(rectObj);
      const updatedPathString = setPathDimensions(
        pathValue,
        Math.max(rectObj.width, MINIMUM_SIZE_SCALING),
        Math.max(rectObj.height, MINIMUM_SIZE_SCALING),
        rectObj.maxWidth,
        rectObj.maxHeight,
      );
      const newRectObj = new fabric.Path(updatedPathString, rectObj);
      rectObj.set({ ...newRectObj });
    }
    this.updateTextObj();
    this.setCoords();
    this.callSuper('render', ctx);
  },
  updateTextAlign() {
    this.updateTextObj();
    const items = ungroup(cloneDeep(this), canvas, true);
    items.forEach((i) => window.canvas.remove(i));
    return { top: items[1].top, left: items[1].left };
  },
});

fabric.TextComponent.fromObject = function (object, callback) {
  fabric.util.enlivenObjects(object.objects, function (enlivenedObjects) {
    const options = fabric.util.object.clone(object, true);
    delete options.objects;
    return callback(new fabric.TextComponent(enlivenedObjects, options, true));
  });
};

export function createTextComponent(obj) {
  let rect = obj;
  if (rect.type === PATH) {
    const pathValue = getPathValue(rect);
    const updatedPathString = setPathDimensions(
      pathValue,
      Math.max(rect.width * rect.scaleX, MINIMUM_SIZE_SCALING),
      Math.max(rect.height * rect.scaleY, MINIMUM_SIZE_SCALING),
    );
    rect = new fabric.Path(updatedPathString, {
      width: rect.width,
      height: rect.height,
      objectCaching: false,
      selectable: false,
      fill: obj.fill,
      strokeWidth: obj.strokeWidth,
      stroke: obj.stroke,
      strokeDashArray: obj.strokeDashArray,
    });
  } else {
    rect.set({ width: rect.width * rect.scaleX, height: rect.height * rect.scaleY, scaleX: 1, scaleY: 1 });
    if (rect.type === CIRCLE) rect.set({ radius: Math.min(rect.width, rect.height) / 2 });
  }

  const text = new fabric.Textbox('', {
    ...DEFAULT_TEXT_STYLE,
    name: 'Text',
    textAlign: 'center',
    originX: 'left',
    isTextComponent: true,
    fill: '#000',
  });

  const textComponent = new fabric.TextComponent([rect, text], {
    id: generateId(),
    name: 'Text Component',
    type: TEXT_COMPONENT,
    textAlignVertical: 'middle',
    top: obj.top,
    left: obj.left,
    width: obj.width * obj.scaleX,
    height: obj.height * obj.scaleY,
    angle: obj.angle,
    objectCaching: false,
    oldId: obj.id,
  });

  return textComponent;
}

export function createCustomObj() {
  const hiddenRect = new fabric.Path(
    'M 19 160 C 13.48 160 9 155.53 9 150 V 90 C 9 84.48 4.53 80 -1 80 C 4.53 80 9 75.53 9 70 V 10 C 9 4.48 13.48 0 19 0',
    {
      width: 100,
      height: 100,
      objectCaching: false,
      selectable: false,
      fill: 'transparent',
      strokeWidth: 1,
      stroke: '#000',
      maxWidth: 20.2,
    },
  );

  const textObj = new fabric.Textbox('', {
    name: 'Text',
    textAlign: 'center',
    originX: 'left',
    isTextComponent: true,
    fill: '#000',
  });

  const obj = new fabric.TextComponent([hiddenRect, textObj], {
    id: generateId(),
    name: CURLY_BRACE_NOTE_LEFT,
    type: TEXT_COMPONENT,
    textAlignVertical: 'middle',
    top: 0,
    left: 0,
    width: 100,
    height: 100,
    objectCaching: false,
    originalName: CURLY_BRACE_NOTE_LEFT,
  });
  return obj;
}

window.fabric.TextComponent = fabric.TextComponent;

export default fabric.TextComponent;
